import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { colors, fontSize } from '../../constants/styleConstants';
import emptyIcon from '../../public/images/icons/empty.png';

const useStyles = makeStyles(() => ({
  emptyStateContainer: {
    display: 'flex',
    justifyContent: 'center',
    margin: '20px 0',
    padding: '45px',
    alignItems: 'center',
    flexDirection: 'column',
    borderRadius: '8px',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.1)',
    border: `solid 1px ${colors.border.grey1}`,
  },
  emptyState: {
    textAlign: 'center',
    width: '300px',
  },
  mainText: {
    fontSize: fontSize.h3,
    color: colors.darkText,
    margin: 0,
    lineHeight: 'normal',
  },
  subText: {
    fontSize: fontSize.basic,
    color: colors.darkText,
    margin: 0,
    lineHeight: 'normal',
    marginTop: 6,
  },
  icon: {
    width: 44,
    height: 44,
  },
}));

const EmptyStateCard = ({ message, subTextMessage }) => {
  const classes = useStyles();

  return (
    <div className={classes.emptyStateContainer}>
      <div className={classes.emptyState}>
        <img src={emptyIcon} className={classes.icon} alt="empty-state" />
        <p className={classes.mainText}>{message}</p>
        {subTextMessage && <p className={classes.subText}>{subTextMessage}</p>}
      </div>
    </div>
  );
};

EmptyStateCard.propTypes = {
  message: PropTypes.string,
  subTextMessage: PropTypes.string,
};

export default EmptyStateCard;
